import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import { appIdentifier } from "@/utils/appIdentifier.js";

import VueHead from "vue-head";
import VueLazyLoad from "vue-lazyload";
import VueAnalytics from "vue-analytics";
import VueGtag from "vue-gtag";

Vue.use(VueHead);
Vue.use(VueLazyLoad);

Vue.config.productionTip = false;

//Set app identifier
const appLocation = window.location.origin;

store.commit("setAppId", appLocation);

if (store.getters.getAppName !== "huygens") {
  Vue.use(VueAnalytics, {
    id:
      process.env[
        `VUE_APP_GOOGLE_ANALYTICS_ID_${store.getters.getAppName.toUpperCase()}`
      ],
    router,
    debug: {
      sendHitTask: process.env.VUE_APP_DEPLOY_ENV == "production"
    }
  });
} else {
  Vue.use(
    VueGtag,
    {
      config: {
        id:
          process.env[
            `VUE_APP_GOOGLE_ANALYTICS_ID_${store.getters.getAppName.toUpperCase()}`
          ]
      }
    },
    router
  );
}

//Style imports
import "@/styles/tailwind.css";
import vuetify from "./plugins/vuetify";
import "@/styles/styles.scss";

//Panorama viewer
import "pannellum";
import "pannellum/build/pannellum.css";

//Set favicon
let link =
  document.querySelector("link[rel*='icon']") || document.createElement("link");
link.rel = "shortcut icon";
link.href = `./${appIdentifier()}/favicon.ico`;
document.getElementsByTagName("head")[0].appendChild(link);

//LightBox
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";

import { Mutations, Actions } from "@/utils/constants/types.js";
Vue.prototype.$actions = Actions;
Vue.prototype.$mutations = Mutations;

//Register global eventbus
const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;

//Base components registration
const files = require.context("./components/global", true, /\.vue$/i);
files.keys().map(key =>
  Vue.component(
    key
      .split("/")
      .pop()
      .split(".")[0],
    files(key).default
  )
);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
